import React from 'react';
export function PrecioFinalSection() {
  return <section className="w-full text-center" style={{
    padding: '35px 16px',
    background: '#f5f5f5'
  }} data-id="element-114">
      {/* Imagen Producto */}
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771287449/2_m2bqoa.png" alt="Método ADN Campeón" style={{
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%',
      maxWidth: '340px',
      borderRadius: '14px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
    }} data-id="element-115" />

      {/* Descargas */}
      <div style={{
      marginTop: '12px',
      fontSize: '13px',
      color: '#9ca3af',
      fontWeight: 600
    }} data-id="element-116">
        +5.200 DESCARGAS
      </div>

      {/* Título */}
      <div style={{
      marginTop: '10px',
      fontSize: '16px',
      fontWeight: 700,
      color: '#111'
    }} data-id="element-117">
        ⚽ Método ADN CAMPEÓN + 5 Regalos Exclusivos 🎁
      </div>

      {/* Tarjeta Precio */}
      <div style={{
      marginTop: '20px',
      background: 'linear-gradient(180deg, #0b0f19, #111827)',
      padding: '22px',
      borderRadius: '18px',
      border: '1px solid #16a34a',
      boxShadow: '0 0 25px rgba(22,163,74,0.3)',
      color: '#fff',
      maxWidth: '500px',
      margin: '20px auto 0'
    }} data-id="element-118">
        <div style={{
        textDecoration: 'line-through',
        color: '#9ca3af',
        fontSize: '14px'
      }} data-id="element-119">
          54,95€
        </div>

        <div style={{
        fontSize: '36px',
        fontWeight: 800,
        color: '#22c55e',
        marginTop: '6px'
      }} data-id="element-120">
          12,95€
        </div>

        <div style={{
        marginTop: '8px',
        background: '#16a34a',
        color: '#000',
        fontWeight: 800,
        padding: '6px 14px',
        borderRadius: '20px',
        display: 'inline-block',
        fontSize: '13px'
      }} data-id="element-121">
          AHORRA 40€
        </div>

        <div style={{
        marginTop: '16px',
        borderTop: '1px solid rgba(255,255,255,0.2)',
        paddingTop: '12px',
        fontSize: '13px',
        color: '#d1d5db'
      }} data-id="element-122">
          🔐Compra Segura   |   ⚡Envío Inmediato
        </div>
      </div>

      {/* Botón CTA fuera de la tarjeta */}
      <a href="https://infoliar.com/cart/56736084721996:1" className="adn-pulse-btn" style={{
      marginTop: '18px',
      width: '100%',
      maxWidth: '500px',
      display: 'block',
      background: 'linear-gradient(90deg, #16a34a, #22c55e)',
      color: '#fff',
      fontWeight: 800,
      padding: '16px',
      border: 'none',
      borderRadius: '40px',
      fontSize: '15px',
      cursor: 'pointer',
      textDecoration: 'none',
      textAlign: 'center',
      boxSizing: 'border-box',
      boxShadow: '0 8px 20px rgba(34,197,94,0.35)',
      margin: '18px auto 0 auto'
    }} aria-label="Quiero mi método - Comprar ahora" data-id="element-123">
        ¡QUIERO MI MÉTODO! ⚽
      </a>

      {/* Imagen Cierre */}
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289893/6x1_xh5tof.png" alt="Método ADN Campeón - Resumen" style={{
      width: '100%',
      marginTop: '30px',
      borderRadius: '12px'
    }} data-id="element-124" />
    </section>;
}